import React, { useEffect } from "react";
import { WelcomeSection, StockAnalytics, Topperformer } from "../../components";

import { strategiesArray } from "../../devdata/constants/mmtData/strategiesArray";

export default function DashboardLayout() {
  const strategies = strategiesArray.slice(0, 6);
  sessionStorage.removeItem("rel")

  return (
    <div className="flex overflow-hidden flex-col bg-darkMode-background">
      <div className="flex flex-col gap-5 flex-1 shrink px-4 md:px-6 rounded-xl basis-0 min-w-[240px] max-md:max-w-full">
        <WelcomeSection />
        <StockAnalytics />
        <h1 className="text-xl md:text-2xl font-bold text-darkMode-text px-4 md:px-0">
          {" "}
          Top Performers
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-4 md:px-0">
          {" "}
          {[
            {
              id: 1,
              title: "Top Gainers",
              description: "Highest % Gain Since Morning",
              top: true,
            },
            {
              id: 2,
              title: "Top Losers",
              description: "Highest % Loss Since Morning",
              top: false,
            },
          ].map((strategy) => (
            <Topperformer key={strategy.id} {...strategy} />
          ))}
        </div>
      </div>
    </div>
  );
}
